import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/remove.svg';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isDialogVisible } from 'reactApp/modules/dialog/dialog.selectors';
import { isUploaderVisible } from 'reactApp/modules/upload/upload.selectors';
import GetLinkBySms from 'reactApp/ui/GetLinkBySms/GetLinkBySms';
import { sendGa } from 'reactApp/utils/ga';
import { noop } from 'reactApp/utils/helpers';

import styles from './BannerRightAdaptive.css';

const CloseIcon = () => <IconClose width={22} height={22} />;

const mapStateToProps = (state) => ({
    isVisible: isUploaderVisible(state) && !isDialogVisible(state),
});

interface IProps {
    onClose(data?): void;
    onClick(): void;
    onShow(): void;
    title: string;
    description: string;
    buttonText: string;
    buttonHorizontalText: string;
    imageUrl: string;
    imageAutoScale: boolean;
    clickUrl: string;
    gaName: string;
    gaCategory: string;
    backColor: string;
    textColor: string;
    btnTextColor: string;
    btnBackColor: string;
    btnBorderRadius: string;
    isHorizontal: boolean;
    withInput: boolean;
    withButton: boolean;
    hideAfterDialog: boolean;
    isVisible: boolean;
}

export class BannerRightAdaptiveComponent extends Component<IProps> {
    public static defaultProps = {
        onClose: noop,
        onClick: noop,
        onShow: noop,
        imageAutoScale: true,
        backColor: '#fff',
        textColor: '#000',
        btnTextColor: '#333',
        btnBackColor: '#fff',
        btnBorderRadius: '8px',
        withInput: false,
        withButton: false,
        isHorizontal: false,
        hideAfterDialog: false,
        isVisible: true,
        gaCategory: 'banner',
    };

    componentDidMount() {
        const { gaName, gaCategory, onShow } = this.props;
        onShow();
        sendGa(gaCategory, 'show', gaName);
    }

    componentDidUpdate(prevProps) {
        if (this.props.hideAfterDialog && prevProps.isVisible && !this.props.isVisible) {
            this.props.onClose({ sendPixel: false });
        }
    }

    handleClick = () => {
        const { gaName, gaCategory, onClick } = this.props;
        sendGa(gaCategory, 'click', gaName);
        onClick();
    };

    handleClose = () => {
        const { gaName, gaCategory, onClose } = this.props;
        sendGa(gaCategory, 'close', gaName);
        onClose({});
    };

    render() {
        const {
            title,
            description,
            buttonText,
            buttonHorizontalText,
            imageUrl,
            clickUrl,
            imageAutoScale,
            backColor,
            textColor,
            btnTextColor,
            btnBackColor,
            btnBorderRadius,
            isHorizontal,
            withInput,
            withButton,
            gaCategory,
        } = this.props;

        return (
            <div
                className={classNames({
                    [styles.root]: true,
                    [styles.horizontal]: isHorizontal,
                    [styles.vertical]: !isHorizontal,
                })}
                style={{
                    backgroundColor: backColor,
                    color: textColor,
                }}
            >
                <div className={styles.close} onClick={this.handleClose}>
                    <CloseIcon />
                </div>
                <img
                    className={classNames({
                        [styles.image]: true,
                        [styles.image_autoScale]: imageAutoScale,
                    })}
                    src={imageUrl}
                />
                <div className={styles.descriptionBlock}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.description}>{description}</div>
                    {isHorizontal && withInput && (
                        <div className={styles.inputBlock}>
                            <GetLinkBySms title="" size="middle" inverseStyle={true} withMobile={false} gaCategory={gaCategory} />
                        </div>
                    )}
                    {withButton && (
                        <div>
                            <a
                                style={{
                                    color: btnTextColor,
                                    backgroundColor: btnBackColor,
                                    borderRadius: btnBorderRadius,
                                }}
                                className={classNames(styles.button, styles.button_vertical)}
                                onClick={this.handleClick}
                                href={clickUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {buttonText}
                            </a>
                            <a
                                style={{
                                    color: btnTextColor,
                                    backgroundColor: btnBackColor,
                                    borderRadius: btnBorderRadius,
                                }}
                                className={classNames(styles.button, styles.button_horizontal)}
                                onClick={this.handleClick}
                                href={clickUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {buttonHorizontalText}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export const BannerRightAdaptive = connect(mapStateToProps)(BannerRightAdaptiveComponent);
